import numeral from 'numeral';

// Constellation
import { Box, ModalTrigger, Text, TextButton } from '@zillow/constellation-10';

// Flux
import { useAppSelector } from '../flux/configureStore';

// Utils/misc
import { RentalGrowthRentEstimateSource } from '@zg-rentals/ts-rental-growth-api-client';
import StringConstants from '../constants/StringConstants';
import type AddressModelType from '../models/Address';

const RENT_ZESTIMATE = (
  <>
    Rent Zestimate
    <Box asChild css={{ verticalAlign: 'baseline' }}>
      <sup>®</sup>
    </Box>
  </>
);

const ZestimateSummary = () => {
  const userProperty: AddressModelType = useAppSelector((state) => state.address);
  const priceFromFilter = useAppSelector((state) => state.filter.price);

  const { rentZestimate, rentZestimateSource } = userProperty;
  const isListingStatsEstimate = rentZestimateSource === RentalGrowthRentEstimateSource.LISTING_STATS;

  let useRentZestimate: boolean;

  if (rentZestimate && !priceFromFilter) {
    useRentZestimate = true;
  } else if (rentZestimate && priceFromFilter && rentZestimate === priceFromFilter) {
    useRentZestimate = true;
  } else if (priceFromFilter) {
    useRentZestimate = false;
  } else {
    useRentZestimate = false;
  }

  const priceBasis = useRentZestimate ? RENT_ZESTIMATE : 'custom price';
  const summaryText =
    useRentZestimate && isListingStatsEstimate ? (
      `Based on the ${StringConstants.COMPARABLE_HOMES_RENT_LABEL.toLowerCase()}`
    ) : (
      <>
        Based on your {priceBasis} of ${numeral(priceFromFilter || rentZestimate).format('0,0')}
      </>
    );

  return (
    <Box css={{ marginBottom: '400' }}>
      <Text asChild>
        <h6>
          {summaryText}{' '}
          <ModalTrigger multiModalTriggerId="change-price-modal">
            <TextButton.Root>
              <TextButton.Label css={{ color: 'text.accent.brand.hero' }}>Adjust rental price</TextButton.Label>
            </TextButton.Root>
          </ModalTrigger>
        </h6>
      </Text>
    </Box>
  );
};

export default ZestimateSummary;
